

window.addEventListener("load", function () {
  function updateNavState(activeIndex) {
    $('#nth-gd-navigation.MS__pc').toggleClass('active', activeIndex > 0);
    $('#nth-gd-navigation.MS__pc .content > a').not('.btn-trangchu').each(function (i) {
      $(this).toggleClass('active', i === activeIndex);
    });
  }

  function bindNavToSwiper(retry = 0) {
    const mainEl = document.querySelector('.main-swiper');
    const mainSwiper = mainEl && mainEl.swiper;
    if (mainSwiper && mainSwiper.on) {
      updateNavState(mainSwiper.activeIndex);
      mainSwiper.on('slideChange', function () {
        updateNavState(this.activeIndex);
      });

      $('#nth-gd-navigation.MS__pc .content > a').not('.btn-trangchu').each(function (i) {
        $(this).on('click', function (e) {
          e.preventDefault();
          if (mainSwiper.slides && mainSwiper.slides[i]) {
            mainSwiper.slideTo(i);
          }
        });
      });
      return;
    }
    if (retry < 30) {
      setTimeout(() => bindNavToSwiper(retry + 1), 100);
    }
  }

  bindNavToSwiper();

  $('#nth-gd-navigation-mb .MS__sprite-nav-menu-mb').on('click', function (e) {
    e.preventDefault();
    $('#nth-gd-navigation-mb .sub-menu').toggleClass('active');
  });

  $(document).on('click', function (e) {
    const $nav = $('#nth-gd-navigation-mb');
    if (!$nav.length) return;
    if (!$(e.target).closest('#nth-gd-navigation-mb').length) {
      $nav.find('.sub-menu').removeClass('active');
    }
  });
});
